import { defineComponent as _defineComponent } from 'vue'
import { computed, toRef } from 'vue'
import { useLocationQuery } from '@/api/locations'

interface Props {
  value?: number | undefined
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationJobColumn',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  value?: number | undefined
}


const locationIdRef = toRef(props, 'value')

const { data: location } = useLocationQuery(locationIdRef)

const formattedLocation = computed<string>(() => {
  if (location.value?.location) return location.value?.location as string
  return ''
})

return { __sfc: true,props, locationIdRef, location, formattedLocation }
}

})